import React, { useState, useEffect, useCallback, useContext, useRef } from "react";

import { Button }      from "primereact/button";
import { DataTable }   from "primereact/datatable";
import { Column }      from "primereact/column";
import { ContextMenu } from "primereact/contextmenu";
import { InputText }         from "primereact/inputtext";
import { TabView, TabPanel } from "primereact/tabview";
import { Dropdown }          from "primereact/dropdown";
import { Skeleton }    from 'primereact/skeleton';


import GlobalContext   from "../../../isp._comun/iu/contexto/GlobalContext";
import Dialogo         from "../../../isp._comun/iu/_principal/componentes/layouts/Dialogo";
import { ModosOp }     from "../../../isp._comun/iu/_principal/constantesIuPrin";
import { TipoDeDoc, TipoDeAsociado } from "../../../isp.žapi.asociados/constantesApiAsociados";
import EliminarVentana from "../../../isp._iu.start.principal/reductores/acciones/widgets/EliminarVentana";

import * as AccionesFact    from "../../reductores/acciones/AccionesTypeFact";
import * as Action          from "../../reductores/acciones/dispatch/_ActionsDispatch";
import ActionAsociadoSet     from "../../reductores/acciones/ActionAsociadoSet";
import ActionSetTipoAsociado from "../../reductores/acciones/dispatch/SetTipoAsociado";

import { EstadosDeAsociado } from "./constantesIuLayoutAsociados";
import * as ModelosDeCombos from "./ModeloDeCombos";


const DialogoAsociadoLayout = ({
    ventana,
    estadoDCF,
    dispatchDCF,
    registrarAsociadoCommand,
    actualizarAsociadoCommand,
    buscarUnSoloAsociadoCommand
}) => {
    const { dispatchPrincipal } = useContext(GlobalContext);
    const [activeIndex, setActiveIndex] = useState(0);
    const [banderaTabPersonasContacto, setBanderaTabPersonasContacto] = useState(false);

    // const nomPersContactInput = useRef(null);
    // const menuListaNombresPersContact = useRef(null);
    //const isMounted = useRef(false);

    useEffect(() => {
        if (estadoDCF.flag.cargandoEntidad) {
            buscarUnSoloAsociadoCommand.ejecutar(estadoDCF.domain.screen.idAsociado);
        }
        return () => {buscarUnSoloAsociadoCommand.cancelar()};
    }, [estadoDCF.flag.cargandoEntidad]);

    useEffect(() => {
            if (!estadoDCF.flag.procesandoComando) {
                return;
            }
            if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) {
                registrarAsociadoCommand.ejecutar();
                return () => {
                    registrarAsociadoCommand.cancelar();
                };
            }
            if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) {
                actualizarAsociadoCommand.ejecutar();
                return () => {
                    actualizarAsociadoCommand.cancelar();
                };
            }
        }, [estadoDCF.flag.procesandoComando]);
    

    const cancelarClick = (eventoSynDom) => {
        dispatchPrincipal(new EliminarVentana(ventana));
        eventoSynDom.stopPropagation();
    };

    const header = {
        elementoReact: <p className="p-2 bg-gradient-to-r from-purple-100">Asociado</p>,
        enProgreso: estadoDCF.flag.procesandoComando,
    };

    const bloqueIdentificacion = (()=>{
        return (
            <div className="flex mb-0 justify-between w-full">
                <div className="mr-10">
                
                    <div className="flex mb-0.5">
                        <div className="w-32">Tipo de Doc. : </div>
                        <div>
                            <Dropdown
                                value={estadoDCF.domain.screen.tipoDoc}
                                options={ModelosDeCombos.tiposDoc}
                                onChange={(e) => {
                                    dispatchDCF(new ActionAsociadoSet("tipoDoc", e.target.value));
                                }}
                                // placeholder="Selecciona un Tipo"
                                className="p-0 w-full rounded-none"
                                // panelClassName="p-0"
                                // panelStyle={{ padding: 0 }}
                                disabled={estadoDCF.flag.procesandoComando}
                            />
                        </div>
                    </div>
                    <div className="flex">
                        <div className="w-32 shrink-0">N° de Doc. : </div>
                        <div>
                            <InputText
                                // id="in"
                                value={estadoDCF.domain.screen.nroDoc}
                                className="p-0 w-24 rounded-none"
                                // className="m-0 p-0 w-10 rounded-none block p-error"
                                onChange={(e) => {
                                    dispatchDCF(
                                        new ActionAsociadoSet("nroDoc", e.target.value)
                                    );
                                }}
                                maxLength={
                                    estadoDCF.domain.screen.tipoDoc === TipoDeDoc.DNI ? 8 : 9
                                }
                                disabled={estadoDCF.flag.procesandoComando}
                            />
                            <small
                                id=""
                                className={
                                    estadoDCF.error.nroDocBlanc ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                Se requiere el Número de Documento.
                            </small>
                            <small
                                id=""
                                className={
                                    estadoDCF.error.nroDocMF ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                El formato de N° de Doc. es incorrecto.
                            </small>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex mb-0.5">
                        <div className="w-24 shrink-0">Apellidos : </div>
                        <div className="pl-0">
                            <InputText
                                id="in"
                                value={estadoDCF.domain.screen.apellidos}
                                className="p-0 w-full rounded-none"
                                onChange={(e) => {
                                    dispatchDCF(new ActionAsociadoSet("apellidos", e.target.value));
                                    console.log("evento apellidos: ", e);
                                }}
                                disabled={estadoDCF.flag.procesandoComando}
                            />
                            <small
                                id=""
                                className={
                                    estadoDCF.error.apellBlanc ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                Se requiere Apellidos del Asociado.
                            </small>
                            <small
                                id=""
                                className={
                                    estadoDCF.error.apellMF ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                El formato de los Apellidos es incorrecto.
                            </small>
                        </div>
                    </div>
                    <div className="flex mb-0.5">
                        <div className="w-24 shrink-0">Nombres : </div>
                        <div className="pl-0">
                            <InputText
                                id="in"
                                value={estadoDCF.domain.screen.nombres}
                                className="p-0 w-full rounded-none"
                                onChange={(e) =>
                                    dispatchDCF(
                                        new ActionAsociadoSet("nombres", e.target.value)
                                        // new Action.SetNombres(e.target.value)
                                    )
                                }
                                disabled={estadoDCF.flag.procesandoComando}
                            />
                            <small
                                id=""
                                className={
                                    estadoDCF.error.nomBlanc ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                Se requiere Nombres del Asociado.
                            </small>
                            <small
                                id=""
                                className={
                                    estadoDCF.error.nomMF ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                El formato de los Nombres es incorrecto.
                            </small>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="w-24 shrink-0">Sexo : </div>
                        <div className="pl-0">
                            <Dropdown
                                value={estadoDCF.domain.screen.sexo}
                                options={ModelosDeCombos.tiposSexo}
                                onChange={
                                    (e) => dispatchDCF(new ActionAsociadoSet("sexo", e.target.value))
                                    // dispatchDCF(new Action.SetSexo(e.value))
                                }
                                placeholder="Seleccionar..."
                                className="p-0 w-full rounded-none"
                                // panelClassName="p-0"
                                // panelStyle={{ padding: 0 }}
                                disabled={estadoDCF.flag.procesandoComando}
                            />
                            <small
                                id=""
                                className={
                                    estadoDCF.error.sexoBlanc ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                Se requiere elegir un Género.
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        );
    })();

    const bloqueTabs =  (
        <TabView
            activeIndex={activeIndex}
            onTabChange={(e) => {
                setActiveIndex(e.index);
                if (e.index === 2) setBanderaTabPersonasContacto(!banderaTabPersonasContacto);
            }}
            className="mt-0"
        >
            <TabPanel header="General">
                <div className="flex mb-0.5 flex-wrap ">
                    <div className="w-36 shrink-0">Telf. Celular 1 : </div>
                    <div className="shrink-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.general.telcel1}
                            className="p-0 w-32 rounded-none"
                            onChange={(e) => {
                                dispatchDCF(
                                    new ActionAsociadoSet("general.telcel1", e.target.value)
                                    /* new Action.SetGeneralTelcel1(
                                        e.target.value
                                    ) */
                                );
                            }}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={
                                estadoDCF.error.telcel1Blanc ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            Se requiere el Número del Primer Celular.
                        </small>
                        <small
                            id=""
                            className={
                                estadoDCF.error.telcel1MF ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            El formato del Número de Teléfono es incorrecto.
                        </small>
                    </div>
                </div>
                <div className="flex mb-0.5 flex-wrap">
                    <div className="w-36 shrink-0">Telf. Celular 2 : </div>
                    <div className="shrink-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.general.telcel2}
                            className="p-0 w-32 rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionAsociadoSet("general.telcel2", e.target.value)
                                    /* new Action.SetGeneralTelcel2(
                                        e.target.value
                                    ) */
                                )
                            }
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={
                                estadoDCF.error.telcel2MF ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            El formato del Número de Teléfono es incorrecto.
                        </small>
                    </div>
                </div>
                <div className="flex mb-0.5 flex-wrap">
                    <div className="w-36 shrink-0">Telf. Fijo : </div>
                    <div className="shrink-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.general.telfijo}
                            className="p-0 w-32 rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionAsociadoSet("general.telfijo", e.target.value)
                                    /* new Action.SetGeneralTelfijo(
                                        e.target.value
                                    ) */
                                )
                            }
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={
                                estadoDCF.error.telfijoMF ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            El formato del Número de Teléfono es incorrecto.
                        </small>
                    </div>
                </div>
                <div className="flex mb-0.5  flex-wrap">
                    <div className="w-36 shrink-0">Email : </div>
                    <div className="shrink-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.general.email}
                            className="p-0 w-full rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionAsociadoSet("general.email", e.target.value)
                                    /* new Action.SetGeneralEmail(
                                        e.target.value
                                    ) */
                                )
                            }
                            // disabled={true}
                        />
                        <small
                            id=""
                            className={
                                estadoDCF.error.emailMF ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            El formato del e-mail es incorrecto.
                        </small>
                    </div>
                </div>
            </TabPanel>
        </TabView>
    );

    const bloqueAtributos=(()=>{
        if(estadoDCF.flag.cargandoEntidad){
            return (
                <>
                    <div className="flex flex-row justify-between">                    
                            <Skeleton width="45%" height="6rem"></Skeleton>               
                            <Skeleton width="40%" height="6rem"></Skeleton>                
                    </div>
                    <br></br>
                    <br></br>
                    <div>
                        <Skeleton width="100%" height="10rem"></Skeleton> 
                    </div>
                </>
            );
            
        }else{
            return (
            <>
                <div className="flex justify-between flex-wrap">{bloqueIdentificacion}</div>
                {bloqueTabs}
            </>
            )
        }
    })();
    
    const labelBotonAccion = (() => {
        if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) return "Guardar";
        if (estadoDCF.flag.modoOperacion === ModosOp.OK) return "   OK    ";
        if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) return "Modificar";
    })();

    const footer = (
        <div>
            <Button
                label={labelBotonAccion}
                icon="pi pi-check"
                onClick={(eventoSynDom) => {
                    if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) {
                        dispatchDCF(new Action.GuardarAsociadoAFacturar());
                        return;
                    }
                    if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) {
                        dispatchDCF(new Action.ActualizarAsociadoAFacturar());
                        return;
                    }
                    if (estadoDCF.flag.modoOperacion === ModosOp.OK) {
                        cancelarClick(eventoSynDom);
                        return;
                    }
                }}
                loading={estadoDCF.flag.procesandoComando}
                iconPos="left"
                className="whitespace-pre"
            />
            <Button
                label="Cancelar"
                icon="pi pi-times"
                onClick={(eventoDom) => cancelarClick(eventoDom)}
                disabled={estadoDCF.flag.procesandoComando}
                // className="w-32"
            />
        </div>
    );

    return (
        <Dialogo
            ventana={ventana}
            cabecera={header}
            modal={estadoDCF.flag.modal}
            posicionZ={ventana.posicionZ}
            pie={footer}
            estilo={{ width: "40rem", minHeight: "50vh", top: "15vh", margin: "0" }}
        >
            <div className="flex justify-between">
                <div>
                    <div className="flex">
                        <div className="w-40">Id. de Asociado : </div>
                        <div>{estadoDCF.domain.screen.idAsociado}</div>
                    </div>
                    <div className="flex">
                        <div className="w-40"></div>
                    </div>
                </div>
                <div>
                    <div className="flex">
                        <div className="w-40 shrink-0">Fecha de Registro : </div>
                        <div>{estadoDCF.domain.screen.fechaReg}</div>
                    </div>
                    <div className="flex">
                        <div className="w-40">Estado : </div>
                        <div>{EstadosDeAsociado[estadoDCF.domain.screen.estado]}</div>
                    </div>
                </div>
            </div>

            <hr className="my-3"></hr>

            {bloqueAtributos}

        </Dialogo>
    );
};

export default DialogoAsociadoLayout;
